import _ from 'lodash';
import {mapMutations} from 'vuex';

const SAVING = 'SAVING';
const SAVED = 'SAVED';
const SAVE_DELAY_MS = 1800;

const SaveMixin = {
  methods: {
    async saveNow() {
      await this.save(this.saveObjectCopy);
      this.setSavingStatus(SAVED);
      if (_.isFunction(this.clearDirty)) this.clearDirty();
    },
    async delayedSave() {
      this.saveTimeout = null;
      await this.saveNow();
    },
    async triggerSaveNow() {
      this.setSavingStatus(SAVING);
      if (this.saveTimeout) clearTimeout(this.saveTimeout);
      this.saveObjectCopy = {...this.saveObject};
      await this.delayedSave();
    },
    triggerSave: _.debounce(function () { // eslint-disable-line
      this.setSavingStatus(SAVING);
      if (this.saveTimeout) {
        clearTimeout(this.saveTimeout);
      }
      this.saveObjectCopy = {...this.saveObject};
      this.saveTimeout = _.delay(this.delayedSave, SAVE_DELAY_MS);
    }, 100, {leading: true, maxWait: 500}),
    async saveOutstanding() {
      if (!this.saveTimeout) return; // No outstanding save
      clearTimeout(this.saveTimeout);
      this.saveTimeout = null;
      await this.saveNow();
    },
    ...mapMutations({
      setSavingStatus: 'setSavingStatus'
    })
  },
  watch: {
    dirty() {
      if (!this.dirty) return;
      this.triggerSave();
    }
  },
  data() {
    return {
      saveTimeout: null,
      saveObjectCopy: null // necessary so we can clear state and still have a snapshot of what we want to save
    };
  }
};
export default SaveMixin;
